// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__Ipv6v","list":"Menu_list__19OBR"};